import React, { useState } from 'react';
import Layout from '../components/Layout/Layout';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API_BASE = "https://api.mbsmartweb.com/api";

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(localStorage.getItem("UserId") || "");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.currentPassword) newErrors.currentPassword = 'Current password is required';
    if (!formData.newPassword) newErrors.newPassword = 'New password is required';
    if (formData.newPassword.length < 6) newErrors.newPassword = 'Password must be at least 6 characters';
    if (formData.newPassword !== formData.confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    
    if (Object.keys(newErrors).length === 0) {
      setLoading(true);
      
      try {
        const response = await axios.post(`${API_BASE}/changepassword`, {
          userId: userId,
          oldPassword: formData.currentPassword,
          newPassword: formData.newPassword,
          confirmNewPassword: formData.confirmPassword,
        });

        if (response.data.status === 1) {
          toast.success(response.data.message || "Password changed successfully!");
          setFormData({ 
            currentPassword: '', 
            newPassword: '', 
            confirmPassword: '' 
          });
        } else {
          toast.error(response.data.message || "Failed to change password");
        }
      } catch (error) {
        console.error("API Error:", error);
        const message = error.response?.data?.message || 
                       error.response?.data?.error || 
                       error.message || 
                       "Something went wrong!";
        toast.error(message);
      } finally {
        setLoading(false);
      }
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <Layout>
      <ToastContainer position="top-center" autoClose={3000} />
      <div className="change-password-page">
        <div className="page-header">
          <h1>Change Password</h1>
          <p>Update your account password</p>
        </div>

        <div className="password-card">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Current Password</label>
              <div className="input-wrapper">
                <i className="fa fa-lock"></i>
                <input
                  type="password"
                  name="currentPassword"
                  value={formData.currentPassword}
                  onChange={handleChange}
                  placeholder="Enter current password"
                  disabled={loading}
                />
              </div>
              {errors.currentPassword && <span className="error-message">{errors.currentPassword}</span>}
            </div>

            <div className="form-group">
              <label>New Password</label>
              <div className="input-wrapper">
                <i className="fa fa-key"></i>
                <input
                  type="password"
                  name="newPassword"
                  value={formData.newPassword}
                  onChange={handleChange}
                  placeholder="Enter new password (min 6 characters)"
                  disabled={loading}
                />
              </div>
              {errors.newPassword && <span className="error-message">{errors.newPassword}</span>}
            </div>

            <div className="form-group">
              <label>Confirm New Password</label>
              <div className="input-wrapper">
                <i className="fa fa-check-circle"></i>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="Confirm new password"
                  disabled={loading}
                />
              </div>
              {errors.confirmPassword && <span className="error-message">{errors.confirmPassword}</span>}
            </div>

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? (
                <>
                  <i className="fa fa-spinner fa-spin"></i> UPDATING...
                </>
              ) : (
                <>
                  <i className="fa fa-save"></i> Update Password
                </>
              )}
            </button>
          </form>

          <div className="password-tips">
            <h4>Password Requirements:</h4>
            <ul>
              <li><i className="fa fa-check-circle"></i> Minimum 6 characters</li>
              <li><i className="fa fa-check-circle"></i> Use uppercase and lowercase letters</li>
              <li><i className="fa fa-check-circle"></i> Include numbers and special characters</li>
              <li><i className="fa fa-check-circle"></i> Don't use common passwords</li>
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ChangePassword;